module.exports = __webpack_public_path__ + "static/media/Intro-AFTER-trail-exercises.59913e55.mp3";